import { render, staticRenderFns } from "./ReceiptsOptions.vue?vue&type=template&id=123cc620&"
import script from "./ReceiptsOptions.vue?vue&type=script&lang=js&"
export * from "./ReceiptsOptions.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsOptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('123cc620')) {
      api.createRecord('123cc620', component.options)
    } else {
      api.reload('123cc620', component.options)
    }
    module.hot.accept("./ReceiptsOptions.vue?vue&type=template&id=123cc620&", function () {
      api.rerender('123cc620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/components/ReceiptsOptions.vue"
export default component.exports